import React from "react";
import { useSelector } from "react-redux";
import { typeStatisticsState } from "model/dashboardStatistics/dStatisticsReducer";
import { Trans } from "@lingui/macro";
import { Alert } from "components/UI/Alert/Alert";
import { DateFilter } from "../../charts/DateFilter/DateFilter";
import { Loader } from "components/UI/Loader/Loader";

export type typeEmployees = {
  variant?: string;
};

export const Products: React.FC<typeEmployees> = () => {
  const productFull = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.productFull,
  );
  const loaderFilter = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.loaderFilter,
  );

  return (
    <>
      <div className="flex flex-col relative gap-y-4">
        <DateFilter />

        <div className="-my-2 overflow-x-auto">
          <div className="py-2 align-middle inline-block min-w-full">
            <div className="relative overflow-hidden border border-gray-200 shadow-sm sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr className="relative bg-gray-600">
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      &nbsp;
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      <Trans>Name</Trans>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      <Trans>Sales amount</Trans>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      <Trans>Count of sales</Trans>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      <Trans>Average check</Trans>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      <Trans>Refunds amount</Trans>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      <Trans>Count of refunds</Trans>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {productFull.length ? (
                    productFull.map((item, index) => (
                      <tr key={index} className="bg-white hover:bg-indigo-50">
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                          {index + 1}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                          {item.name}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right">
                          {item.saleTotalAmount.toFixed(2)}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                          {item.saleCount}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right">
                          {item.saleAverageAmount.toFixed(2)}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right">
                          {item.refundTotalAmount.toFixed(2)}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                          {item.refundCount}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="p-2">
                        <Alert
                          type="info"
                          title={<Trans>No data. Change the period.</Trans>}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {loaderFilter ? <Loader /> : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
